import React, { useContext, useState } from 'react';
import ReactCountryFlag from "react-country-flag";
import { FormControl, MenuItem, Select } from '@mui/material';
import AuthContext from '../../authContext';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { changeCurrency, changeLanguage } from '../../../redux/productSlice';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button } from "antd";
import InfoIcon from '@mui/icons-material/Info';
import { useNavigate } from 'react-router-dom';
import { TfiWorld } from "react-icons/tfi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  border: "2px solid #ACACAC",
  borderRadius: "1em",
  boxShadow: 24,
  display:'flex',
  flexDirection:'column',
  p: 4,
};

export default function CurrencyLangButton() {
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const currency = useSelector((state) => state.products.selectedCurrency[0].currency);
  const user = useSelector((state) => state.products.userInfo);
  const authCtx = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openmodal, setOpenmodal] = useState(false);
  const [openLanguage, setOpenLanguage] = useState(false);
  const [openCurrency, setOpenCurrency] = useState(false);

  const getToken = () => {
    return sessionStorage.getItem("token");
  };

  const token = getToken();

  const handleCloseModal = () => {
    setOpenmodal(false);
  };

  const handleChangeCurrency = async (event) => {
    const cur = event.target.value;

    if (currency === 'eur' && !authCtx.currencyRate) {
      return setOpenmodal(true);
    }

    dispatch(changeCurrency({ currency: cur }));

    try {
      await axios.put(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
        { currency: cur },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error updating currency:", error);
    }
  };

  const handleChangeLanguage = async (event) => {
    const lan = event.target.value;
    dispatch(changeLanguage({ Language: lan }));
    try {
      await axios.put(
        `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
        { 'language': lan },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error("Error updating language:", error);
    }
  };

  const defaultStyle = {
    padding:'.3em 1.5em',
    color:'#111',
    textAlign:'center',
    border:'1px solid var(--primary-color)',
    width: 'fit-content',
    height:'fit-content',
    display:'flex',
    alignItems:'center',
    borderRadius:'2em 0',
    whiteSpace:'nowrap',
    fontSize:'calc(0.7rem + 0.3vw)',
    backgroundColor:'transparent',
    cursor:'pointer',
    margin:'auto 0',
    transition: "background-color 0.3s, color 0.3s",
    position:'relative',
  };

  return (
    <>
    <button style={defaultStyle} variant="contained">
    <TfiWorld style={{fontSize:'1.4em',margin:"0 .8em 0em 0", color:"var(--primary-color)"}}/>
     <span onClick={() => setOpenLanguage(true)} style={{position:'relative'}}>{language === 'eng' ? (<ReactCountryFlag countryCode="GB" svg style={{ marginRight: '0' }} />) : (<ReactCountryFlag countryCode="FR" svg style={{ marginRight: '0' }} />)}</span>
      <FormControl
        style={{ display: openLanguage ? 'inline-block' : 'none',position:'absolute', top:'-1em', left:'0',opacity:0 }}
      >
        <Select
          open={openLanguage}
          onClose={() => setOpenLanguage(false)}
          onOpen={() => setOpenLanguage(true)}
          value={language}
          onChange={handleChangeLanguage}
        >
          <MenuItem value="eng">
            <ReactCountryFlag countryCode="GB" svg style={{ marginRight: '0.5em' }} />
            English
          </MenuItem>
          <MenuItem value="fr">
            <ReactCountryFlag countryCode="FR" svg style={{ marginRight: '0.5em' }} />
            Français
          </MenuItem>
        </Select>
      </FormControl>
      <span style={{color:"var(--primary-color)",padding:'0 .6em'}}> | </span> <span onClick={() => setOpenCurrency(true)} style={{fontWeight:"700"}}>{currency === 'eur' ? '€' : '$'}</span>
      <FormControl
        style={{ display: openCurrency ? 'inline-block' : 'none',position:'absolute', top:'-1em', right:'0',opacity:0 }}
        >
        <Select
          open={openCurrency}
          onClose={() => setOpenCurrency(false)}
          onOpen={() => setOpenCurrency(true)}
          value={currency}
          onChange={handleChangeCurrency}
        >
          <MenuItem value="eur">Euro (€)</MenuItem>
          <MenuItem value="usd">Dollar ($)</MenuItem>
        </Select>
      </FormControl>
    </button>
    <Modal
        open={openmodal}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <InfoIcon style={{color:"red",margin:"0 auto .5em auto",fontSize:"3em"}}/>
        <h3 style={{color:"red"}}>{language === "eng" ? "You cannot change the currency. Please contact the administration." : "Vous ne pouvez pas changer la devise. Veuillez contacter l\'administration."}</h3>
        <div style={{width:'fit-content',margin:'auto',display:'flex',flexWrap:'wrap'}}>
        <Button
           onClick={()=>{handleCloseModal(); navigate(`/contactus`)}}
          style={{backgroundColor:'var(--primary-color)',color: 'white', height:'3em',width:'10em',borderRadius:'3em 0',margin:'2em auto 0 auto'}}>
            {language === "eng" ? "Contact us" : "Nous contacter"}
          </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
